var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"align-center pa-0",staticStyle:{"max-width":"var(--max-width)"},style:(_vm.styleContainer)},[_c('v-card',{attrs:{"height":_vm.height,"flat":""}},[_c('div',{attrs:{"id":"map-container"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }